export const PRIMATOO_BASE_ENVIRONMENT = {
  production: false,
  endPoint: '',
  recaptchaV3: {
    siteKey: '6LfR--QfAAAAAK5j1qCWRolGZhXOUfWBCk08LYCJ',
  },
  enabledWidgetStat: true,
  inactivityTime: 600000, // 600000, // 10 minuti
  connectionAttempts: 2,
  pollingTime: 10000, // 10 secondi
  lockDurationSec: 30, //30 secondi
  uiConfig: {
    dateFormats: {
      en: 'MM/dd/yyyy HH:mm',
      it: 'dd/MM/yyyy HH:mm',
    },
  },
  defaultGridOptions: {
    animateRows: false,
    pagination: false,
    rowSelection: 'multiple',
    rowHeight: 30,
    floatingFiltersHeight: 30,
    defaultColDef: {
      cellStyle: { 'line-height': '30px', 'font-size': '12px' },
    },
  },
  defaultContextMenuItems: [],
  initialTutorial: {
    id: 1,
    title: '1. Data Protection Governance Primatoo Cloud',
    link: 'https://www.youtube.com/embed/mNTnMIRkQMk?autoplay=1&mute=1',
    logo: '/assets/images/tutorials-pictures/data_protection_governance.png',
    description:
      'Come creare le informazioni di base per alimentare il sistema Primatoo (Società, Risorse, Applicativi, Finalità…)',
  },
  tutorials: [
    {
      id: 1,
      title: '1. Data Protection Governance Primatoo Cloud',
      link: 'https://www.youtube.com/embed/mNTnMIRkQMk',
      description:
        'Come creare le informazioni di base per alimentare il sistema Primatoo (Società, Risorse, Applicativi, Finalità…)',
      logo: '/assets/images/tutorials-pictures/data_protection_governance.png',
    },
    {
      id: 2,
      title: '2. Compilare un Trattamento',
      link: 'https://www.youtube.com/embed/X-4tltUPqn4',
      description:
        'I passi per registrare un trattamento nel Registro del titolare',
      logo: '/assets/images/tutorials-pictures/compilare_un_trattamento.png',
    },
    {
      id: 3,
      title: '3. Avviare un nuovo trattamento da Responsabile',
      link: 'https://www.youtube.com/embed/zvJW5sSzBak',
      description:
        'I passi per registrare un trattamento nel Registro del responsabile',
      logo: '/assets/images/tutorials-pictures/avviare_un_nuovo_trattamento_da_responsabile.png',
    },
    {
      id: 4,
      title: '4. Inserire un Applicativo in Primatoo',
      link: 'https://www.youtube.com/embed/beRd9r2rkGg',
      description:
        'Quali informazioni caricare per registrare gli strumenti elettronici utilizzati nei trattamenti',
      logo: '/assets/images/tutorials-pictures/inserire_un_applicativo.png',
    },
    {
      id: 5,
      title:
        '5. Assessment misure di sicurezza tecniche con Primatoo (assessment applicativi)',
      link: 'https://www.youtube.com/embed/gLU9YzeoKXg',
      description:
        'Valutare la sicurezza tecnica di un applicativo mediante Primatoo',
      logo: '/assets/images/tutorials-pictures/assessment_misure_di_sicurezza_tecniche.png',
    },
    {
      id: 6,
      title: '6. Gestione "nomine" Autorizzati',
      link: 'https://www.youtube.com/embed/PFH7BQ9A4Co',
      description: 'Come il sistema supporta la gestione delle nomine',
      logo: '/assets/images/tutorials-pictures/gestione_nomine_autorizzati.png',
    },
    {
      id: 7,
      title: '7.1 Risk Assessment trattamenti (1 di 2)',
      link: 'https://www.youtube.com/embed/2OVQUBrk-7k',
      description:
        'Il processo guidato per valutare la sicurezza di un trattamento – 1',
      logo: '/assets/images/tutorials-pictures/risk_assessment_trattamenti_1.png',
    },
    {
      id: 8,
      title: '7.2 Risk Assessment trattamenti (2 di 2)',
      link: 'https://www.youtube.com/embed/9Kf4wJ9d3I4',
      description:
        'Il processo guidato per valutare la sicurezza di un trattamento – 2',
      logo: '/assets/images/tutorials-pictures/risk_assessment_trattamenti_2.png',
    },
    {
      id: 9,
      title: '8.1 DPIA (1 di 2)',
      link: 'https://www.youtube.com/embed/t8JX4kWQ83s',
      description: 'Effettuare una DPIA – 1',
      logo: '/assets/images/tutorials-pictures/dpia_1.png',
    },
    {
      id: 10,
      title: '8.2 DPIA (2 di 2)',
      link: 'https://www.youtube.com/embed/6plrUcnQZng',
      description: 'Effettuare una DPIA – 2',
      logo: '/assets/images/tutorials-pictures/dpia_2.png',
    },
  ],
  version: '89a4252d1',
  logLevel: 'DEBUG',
  oauth: {
    spDomain: '/api/org/oauth2/authorization/azure-<domain>',
  },
};
